/* ===========================================================================
   DE KLEURENWAAIER: snel in de mand

   Het plusje rechtsboven op een kaart is een gewoon formulier naar
   /cart/add. Zonder dit script doet het precies wat een formulier doet: de
   fles gaat in de mand en Shopify toont de winkelwagen. Met dit script blijft
   de bezoeker waar hij is:

   1. de fles gaat via /cart/add.js in de mand;
   2. uit het plusje komt het silhouet van die fles, in de inkt van zijn
      geurfamilie, en zweeft in een boog naar het tasje rechtsboven;
   3. het tasje tikt aan en telt mee, het plusje wordt even een vinkje.

   Het silhouet is geen tekening. Het is de echte productfoto, gebruikt als
   masker: de uitgeknipte PNG levert de vorm, de familie levert de kleur. Op
   die foto staan doos en fles naast elkaar; alleen de fles vliegt, op
   verzoek van de eigenaar. Een foto zonder doorzichtige achtergrond (een
   JPG) heeft geen vorm om uit te knippen; die vliegt als een klein kleurvlak
   in dezelfde inkt.

   Een uitverkochte geur heeft hetzelfde plusje, maar als knop zonder
   formulier ([data-kw-uit]). Een klik daarop vraagt Shopify niets: het
   plusje wordt een rood kruis, schudt nee en toont "Uitverkocht". Dezelfde
   reactie volgt als een geur uitverkocht raakt terwijl de pagina al open
   staat en Shopify het toevoegen daarom weigert.

   De verzendtab en kw.js hoeven niets te weten van dit script: zij luisteren
   allebei al naar elke aanroep naar /cart/add en werken zichzelf bij.
   ======================================================================== */

(function () {
  'use strict';

  if (window.__kwSnel) return;
  window.__kwSnel = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function stil() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* --- Wat een schermlezer hoort ----------------------------------------
     Eén statusregel voor de hele pagina, visueel verborgen. De tekst wordt
     eerst geleegd en dan gezet, zodat twee keer dezelfde melding na elkaar
     ook twee keer wordt voorgelezen. */
  var regel = null;
  function meld(tekst) {
    if (!regel) {
      regel = document.createElement('p');
      regel.setAttribute('role', 'status');
      regel.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0';
      document.body.appendChild(regel);
    }
    regel.textContent = '';
    window.setTimeout(function () { regel.textContent = tekst; }, 40);
  }

  /* --- Het tasje -------------------------------------------------------- */
  function tasje() {
    var el = document.querySelector('.kw-head-bar__cart');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    /* Bij het scrollen schuift de hele balk boven het scherm uit, en een
       verborgen tasje heeft geen maat. In beide gevallen telt het niet als
       doel. */
    if (r.width === 0 || r.bottom <= 0 || r.top >= window.innerHeight) return null;
    return { el: el, x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }

  function doel() {
    var t = tasje();
    if (t) return t;
    /* Geen tasje in beeld: dan vliegt de fles naar de hoek waar het tasje
       hoort, rechtsboven, en daar het scherm uit. */
    return { el: null, x: window.innerWidth - 28, y: 20 };
  }

  function tel() {
    fetch(root + 'cart.js', { headers: { 'X-Requested-With': 'kw' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (cart) {
        var n = cart.item_count;
        var label = 'Tas, ' + n + ' ' + (n === 1 ? 'artikel' : 'artikelen');

        Array.prototype.forEach.call(document.querySelectorAll('.kw-head-bar__n'), function (el) {
          el.textContent = String(n);
        });
        Array.prototype.forEach.call(document.querySelectorAll('.kw-head-bar__cart'), function (el) {
          el.setAttribute('aria-label', label);
          el.classList.toggle('is-filled', n > 0);
        });
      })
      .catch(function () {});
  }

  function tik(el) {
    if (!el || stil()) return;
    el.classList.remove('is-tik');
    void el.offsetWidth;
    el.classList.add('is-tik');
    window.setTimeout(function () { el.classList.remove('is-tik'); }, 600);
  }

  /* --- De fles uit de foto ------------------------------------------------
     De productfoto's tonen doos en fles naast elkaar, met een smalle strook
     lucht ertussen. De foto wordt verkleind op een canvas gelegd en per kolom
     wordt gekeken of er iets staat; het meest rechtse blok is de fles. Staat
     er maar een blok, dan is dat het. Van dat blok wordt de omtrek bepaald,
     als deel van de hele foto, zodat het masker straks zo geschaald en
     verschoven kan worden dat precies de fles het vlak vult.

     Lukt het meten niet (een foto van een ander domein mag een canvas niet
     lezen), dan gelden de maten van het vaste fotosjabloon van de winkel:
     39 van de 39 uitsneden hebben de fles op dezelfde plek. Elke foto wordt
     een keer gemeten. */
  var SJABLOON = { x: 0.5125, y: 0.2375, w: 0.3625, h: 0.5292 };
  var flessen = {};

  function fles(img, bron) {
    if (flessen[bron]) return flessen[bron];
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!nw || !nh) return SJABLOON;

    var uit = SJABLOON;
    try {
      var W = 160;
      var H = Math.max(1, Math.round(W * nh / nw));
      var doek = document.createElement('canvas');
      doek.width = W;
      doek.height = H;
      var pen = doek.getContext('2d');
      pen.drawImage(img, 0, 0, W, H);
      var a = pen.getImageData(0, 0, W, H).data;
      var x, y;

      var vol = [];
      for (x = 0; x < W; x++) {
        vol[x] = false;
        for (y = 0; y < H; y++) {
          if (a[(y * W + x) * 4 + 3] > 128) { vol[x] = true; break; }
        }
      }

      var x1 = W - 1;
      while (x1 >= 0 && !vol[x1]) x1--;
      var x0 = x1;
      while (x0 > 0 && vol[x0 - 1]) x0--;

      if (x1 >= 0) {
        var y0 = H;
        var y1 = -1;
        for (y = 0; y < H; y++) {
          for (x = x0; x <= x1; x++) {
            if (a[(y * W + x) * 4 + 3] > 128) {
              if (y < y0) y0 = y;
              y1 = y;
              break;
            }
          }
        }
        /* Een pixel lucht rondom, zodat de zachte rand van de uitsnede niet
           wordt afgesneden. */
        x0 = Math.max(0, x0 - 1);
        x1 = Math.min(W - 1, x1 + 1);
        y0 = Math.max(0, y0 - 1);
        y1 = Math.min(H - 1, y1 + 1);
        if (y1 > y0) uit = { x: x0 / W, y: y0 / H, w: (x1 - x0 + 1) / W, h: (y1 - y0 + 1) / H };
      }
    } catch (e) {
      uit = SJABLOON;
    }

    flessen[bron] = uit;
    return uit;
  }

  /* --- De vlucht ----------------------------------------------------------
     Twee lagen, twee curves: de buitenste beweegt alleen horizontaal en
     versnelt naar het eind, de binnenste beweegt alleen verticaal en is het
     snelst aan het begin. Samen geeft dat een boog: de fles komt omhoog uit
     het plusje en zwaait dan opzij het tasje in, zoals je iets in een tas
     gooit. Alleen transform en opacity, dus het draait op de compositor. */
  function vlieg(knop, kaart) {
    var naar = doel();
    if (stil()) { tik(naar.el); return; }

    var foto = kaart && kaart.querySelector('.kw-chip__shot');
    var bron = foto ? (foto.currentSrc || foto.src || '') : '';
    var uitgeknipt = /\.png(\?|$)/i.test(bron.split('#')[0]);
    var inkt = kaart ? window.getComputedStyle(kaart).getPropertyValue('--fam').trim() : '';

    var buiten = document.createElement('div');
    buiten.className = 'kw-vlieg' + (uitgeknipt ? '' : ' kw-vlieg--vlak');
    buiten.setAttribute('aria-hidden', 'true');
    var vorm = document.createElement('div');
    vorm.className = 'kw-vlieg__vorm';
    if (inkt) vorm.style.setProperty('--kw-vlieg-inkt', inkt);
    if (uitgeknipt) vorm.style.setProperty('--kw-vlieg-masker', 'url("' + bron.replace(/"/g, '%22') + '")');
    buiten.appendChild(vorm);
    document.body.appendChild(buiten);

    /* De hoogte komt uit de CSS; de breedte volgt uit de fles. Het masker
       wordt zo groot gemaakt dat de fles precies die hoogte heeft, en zo ver
       naar links en boven geschoven dat de doos buiten het vlak valt. */
    var hoog = vorm.offsetHeight || 64;
    if (uitgeknipt) {
      var f = fles(foto, bron);
      var nw = foto.naturalWidth || 2;
      var nh = foto.naturalHeight || 3;
      var schaal = hoog / (f.h * nh);
      vorm.style.setProperty('--kw-vlieg-b', Math.round(f.w * nw * schaal) + 'px');
      vorm.style.setProperty('--kw-vlieg-maat', (nw * schaal).toFixed(1) + 'px ' + (nh * schaal).toFixed(1) + 'px');
      vorm.style.setProperty('--kw-vlieg-plek', (-f.x * nw * schaal).toFixed(1) + 'px ' + (-f.y * nh * schaal).toFixed(1) + 'px');
    }
    var breed = vorm.offsetWidth || hoog;

    var van = knop.getBoundingClientRect();
    var x0 = van.left + van.width / 2 - breed / 2;
    var y0 = van.top + van.height / 2 - hoog / 2;
    var x1 = naar.x - breed / 2;
    var y1 = naar.y - hoog / 2;
    var afstand = Math.sqrt((x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0));
    var duur = Math.max(560, Math.min(980, 440 + afstand * 0.42));

    var klaar = false;
    function opruimen() {
      if (klaar) return;
      klaar = true;
      if (buiten.parentNode) buiten.parentNode.removeChild(buiten);
      tik(naar.el);
    }

    if (!buiten.animate) {
      opruimen();
      return;
    }

    buiten.style.transform = 'translateX(' + x0 + 'px)';
    vorm.style.transform = 'translateY(' + y0 + 'px) scale(0.15)';

    var ax = buiten.animate(
      [{ transform: 'translateX(' + x0 + 'px)' }, { transform: 'translateX(' + x1 + 'px)' }],
      { duration: duur, easing: 'cubic-bezier(0.55, 0, 0.8, 0.5)', fill: 'forwards' }
    );
    var ay = vorm.animate(
      [
        { transform: 'translateY(' + y0 + 'px) scale(0.15)', opacity: 0 },
        { transform: 'translateY(' + (y0 - 22) + 'px) scale(1)', opacity: 1, offset: 0.2 },
        { transform: 'translateY(' + y1 + 'px) scale(0.3)', opacity: 0.92 }
      ],
      { duration: duur, easing: 'cubic-bezier(0.25, 0.7, 0.35, 1)', fill: 'forwards' }
    );

    /* Niet alleen op de animatie wachten. In een tabblad dat niet wordt
       getekend staan animaties stil en komt `finished` nooit; dan ruimt de
       klok op. */
    Promise.all([ax.finished, ay.finished]).then(opruimen, opruimen);
    window.setTimeout(opruimen, duur + 400);
  }

  /* --- Uitverkocht -------------------------------------------------------- */
  function nee(houder, naam) {
    if (!houder) return;
    houder.classList.add('is-uit');
    var knop = houder.querySelector('.kw-chip__plus');
    if (knop) {
      knop.setAttribute('aria-disabled', 'true');
      knop.setAttribute('aria-label', naam + ' is uitverkocht');
    }

    houder.classList.remove('is-schud');
    void houder.offsetWidth;
    if (!stil()) houder.classList.add('is-schud');
    window.setTimeout(function () { houder.classList.remove('is-schud'); }, 520);

    houder.classList.add('is-label');
    window.clearTimeout(houder.__kwLabel);
    houder.__kwLabel = window.setTimeout(function () { houder.classList.remove('is-label'); }, 2600);

    meld(naam + ' is uitverkocht.');
  }

  document.addEventListener('click', function (ev) {
    var knop = ev.target && ev.target.closest ? ev.target.closest('[data-kw-uit] .kw-chip__plus') : null;
    if (!knop) return;
    ev.preventDefault();
    var houder = knop.closest('[data-kw-uit]');
    nee(houder, houder.getAttribute('data-naam') || 'Deze geur');
  });

  /* --- Het formulier ------------------------------------------------------
     Gedelegeerd op het document, zodat ook kaarten werken die later op de
     pagina komen: na filteren, in een schuifrij, of via de Section Rendering
     API. */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[data-kw-snel]')) return;
    ev.preventDefault();

    var knop = form.querySelector('button');
    if (!knop || knop.getAttribute('aria-busy') === 'true') return;

    var kaart = form.closest('.kw-chip');
    var naam = form.getAttribute('data-naam') || 'De geur';

    /* Al eerder geweigerd op deze pagina: niet opnieuw vragen. */
    if (form.classList.contains('is-uit')) { nee(form, naam); return; }

    knop.setAttribute('aria-busy', 'true');
    knop.classList.remove('is-erin', 'is-fout');
    knop.classList.add('is-bezig');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'kw' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) return Promise.reject({ status: r.status, kop: j && j.message, tekst: j && j.description });
          return j;
        });
      })
      .then(function () {
        vlieg(knop, kaart);
        knop.classList.add('is-erin');
        meld(naam + ' ligt in je mand.');
        tel();
      })
      .catch(function (fout) {
        if (fout && fout.status === 422 && /uitverkocht/i.test(fout.tekst || '')) {
          nee(form, naam);
          return;
        }
        knop.classList.add('is-fout');
        /* Uitverkocht of een maximum bereikt: daarvoor geeft Shopify een zin in
           de taal van de winkel, en die staat dan ook als kop in het antwoord.
           Bij een technische fout is de kop het Engelse 'Cart Error' en de
           tekst ook Engels; dan een eigen zin. */
        var zin = fout && fout.status === 422 && fout.kop && fout.kop !== 'Cart Error' && fout.tekst;
        meld(zin || (naam + ' kon niet in je mand. Probeer het op de productpagina.'));
      })
      .then(function () {
        knop.removeAttribute('aria-busy');
        knop.classList.remove('is-bezig');
        window.setTimeout(function () {
          knop.classList.remove('is-erin', 'is-fout');
        }, 1600);
      });
  });
})();
